export const format1 = (n, currency = '') => {
    return n.toFixed(2).replace(/./g, function(c, i, a) {
        return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? " " + c : c;
    }) + ' ' + currency;
}


export const format2 = (n, currency = '') => {
    return n.toFixed(0).replace(/./g, function(c, i, a) {
        return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? " " + c : c;
    }) + ' ' + currency;
}

export const formatDate1 = dateString => {
  const arr = dateString.split('/');
  const m = arr[0].length === 1 ? '0' + arr[0] : arr[0];
  return arr[1] + '.' + m + '.' + arr[2];
}



// WEBPACK FOOTER //
// ./src/utils/format.js